import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { EnquiriesStore } from "@store/enquiries";
import { ConstantsStore } from "@store/constants";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { Enquiry } from "@models/enquiry";
import { Course } from "@models/course";
import { MatrixClass } from "@models/matrix-class";
import { ENQUIRY_ACTIVE_DECREMENT_STEP, FETCH_ENQUIRY_CLASSES } from "@reducers/enquiries";
import { Term } from "@models/term";

@Component({
  selector: 'online-enrolment-quick-details',
  templateUrl: './online-enrolment-quick-details.pug',
})
export class OnlineEnrolmentQuickDetailsComponent implements OnInit, OnDestroy {

  public enquiry: Enquiry
  public courses: Course[]
  public classes: MatrixClass[] = []

  public terms: Term[]
  public upcomingNormalTerm: Term = null
  public upcomingHolidayTerm: Term = null

  private enquirySubscription: Subscription
  private constantsSubscription: Subscription

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.enquirySubscription =
      this.store.select("enquiriesReducer").subscribe((s: EnquiriesStore) => {
        this.enquiry    = s.activeEnquiry
        this.classes    = s.classes
      })

    this.constantsSubscription =
      this.store.select("constantsReducer").subscribe((s: ConstantsStore) => {
        this.courses      = s.constants.courses
        this.terms        = s.constants.terms
        this.setUpcomingTerm()
      })

    this.refreshPotentialClasses()
  }

  setUpcomingTerm() {
    this.upcomingNormalTerm = this.terms.find((t: Term) => {
      return t.isOnlineEnrolmentEnabled && !t.isHoliday })

    this.upcomingHolidayTerm = this.terms.find((t: Term) => {
      return t.isOnlineEnrolmentEnabled && t.isHoliday })
  }

  clickedBack() {
    this.store.dispatch({ type: ENQUIRY_ACTIVE_DECREMENT_STEP })
  }

  getCourses(): Course[] {
    return this.courses.filter((c) => this.enquiry.courseIds.includes(c.id))
  }

  getMatrixClasses(): MatrixClass[] {
    return this.classes.filter((c) => this.enquiry.matrixClassIds.includes(c.id))
  }

  refreshPotentialClasses() {
    if (this.enquiry.campusIds.length > 0 && this.enquiry.courseIds.length > 0) {

      const termIds = []
      if (this.upcomingHolidayTerm) { termIds.push(this.upcomingHolidayTerm.id) }
      if (this.upcomingNormalTerm)  { termIds.push(this.upcomingNormalTerm.id) }

      const params = {
        termId: termIds,
        campusIds: this.enquiry.campusIds,
        courseIds: this.enquiry.courseIds,
      }

      this.store.dispatch({ type: FETCH_ENQUIRY_CLASSES, payload: params })
    }
  }

  ngOnDestroy() {
    this.enquirySubscription.unsubscribe()
    this.constantsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-quick-details.ts